import { Box, Stack } from "@mui/material";
import { t } from "i18next";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import DeleteAlert from "../../../components/Alerts/DeleteAlert";
import AppContainer from "../../../components/AppContainer";
import AppLoader from "../../../components/AppLoader";
import GlobalButton from "../../../components/CustomButton";
import GlobalTable from "../../../components/Tables/GlobalTable";
import {
  deleteCompanyRole,
  getAllCompanyRole,
} from "../../../services/company/roleApiFn";
import { handleOpenSnackBar } from "../../../utils";
import AddEditCompanyRoleDialog from "./AddEditRoleDialog";

const headerData = ["role", "assignedPages", "actions"];

const tableRows = ["role_name", "assigned_pages", "actions"];

function AllRolls() {
  const openDialog = useRef();
  const openDeleteDialog = useRef(null);
  const [allRole, setAllRole] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const userData = useSelector((state) => state.userData.user);

  useEffect(() => {
    fetchAllCompanyRole();
  }, []);

  const fetchAllCompanyRole = async () => {
    try {
      setIsLoading(true);
      const response = await getAllCompanyRole(userData?.adminId);
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllRole(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditRole = (row, ind) => {
    openDialog.current.openDialog({
      type: "edit",
      data: row,
      getData: fetchAllCompanyRole,
    });
  };

  const handleOpenDeleteDialog = (params) => {
    openDeleteDialog.current.openDialog({
      data: params.row,
      warningText: t("confirmDeleteRole"),
    });
  };

  const handleDelete = async (params) => {
    console.log(params, "asdasjdsajdsadjas");
    try {
      setIsLoading(true);
      const response = await deleteCompanyRole(params.data._id);
      if (response.data.status) {
        openDeleteDialog.current.closeDialog();
        fetchAllCompanyRole();
        handleOpenSnackBar("success", response.data.message);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <Box height={40}>
          <GlobalButton
            variant={"contained"}
            btnText={"createNewRoles"}
            styleProps={{ fontWeight: 400, width: "auto" }}
            handleClickBtn={() =>
              openDialog.current.openDialog({
                type: "add",
                data: null,
                getData: fetchAllCompanyRole,
              })
            }
          />
        </Box>
      </Stack>
    );
  };
  return (
    <>
      <AppLoader isVisible={isLoading} />
      <AppContainer
        primaryHeading={t("createRoles")}
        secondaryHeading={t("rolesDescription")}
        headProps={renderRightPart()}
      >
        <GlobalTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allRole}
          showActions={true}
          showEdit={true}
          handleEdit={handleEditRole}
          showDelete={true}
          handleDelete={handleOpenDeleteDialog}
        />
      </AppContainer>
      <AddEditCompanyRoleDialog ref={openDialog} />
      <DeleteAlert ref={openDeleteDialog} handleDelete={handleDelete} />
    </>
  );
}

export default AllRolls;
